import { Buffer } from 'buffer'

const globalScope = globalThis as any

if (typeof globalScope.global === 'undefined') {
  globalScope.global = globalScope
}

if (typeof globalScope.Buffer === 'undefined') {
  globalScope.Buffer = Buffer
}

if (typeof globalScope.process === 'undefined') {
  globalScope.process = {}
}

globalScope.process.env = globalScope.process.env || { NODE_ENV: 'production' }
globalScope.process.browser = true
globalScope.process.version = globalScope.process.version || ''
globalScope.process.nextTick =
  globalScope.process.nextTick ||
  ((cb: (...args: any[]) => void, ...args: any[]) =>
    Promise.resolve().then(() => cb(...args)))
